const serverURL = "https://asia-east2-ankk-1db9a.cloudfunctions.net/app/";

export const fetchDobTraits = async (data) => {
	let response = await fetch(serverURL+'traits',{
						method:'post',
						headers: {
							'Content-Type': 'application/json',
						},
						body:JSON.stringify(data),
					});
	if (response.status >= 200 && response.status <= 299){
		let returnData = await response.json();
		return returnData;
	}
	else{
		throw response.status;
	}
}

export const fetchProfessions = async ({dob,sex,D,C,loshuGrid}) =>{
	let data;
	if(D !== undefined && C!== undefined && loshuGrid!== undefined)
		data = {loshuGrid,D,C};
	else
		data = {dob,sex};
	let response = await fetch(serverURL+'professions',{
						method:'post',
						headers: {
							'Content-Type': 'application/json',
						},
						body:JSON.stringify(data),
					});
	if (response.status >= 200 && response.status <= 299){
		let returnData = await response.json();
		return returnData;
	}
	else{
		throw response.status;
	}
}

export const fetchLuckyNumbers = async ({dob,sex,D,C,loshuGrid}) =>{
	let data;
	if(D !== undefined && C!== undefined && loshuGrid!== undefined)
		data = {loshuGrid,D,C};
	else
		data = {dob,sex};
	let response = await fetch(serverURL+'luckynumbers',{
						method:'post',
						headers: {
							'Content-Type': 'application/json',
						},
						body:JSON.stringify(data),
					});
	if (response.status >= 200 && response.status <= 299){
		let returnData = await response.json();
		return returnData;
	}
	else{
		throw response.status;
	}
}

export const fetchNameCompatibility = async ({dob,sex,D,C,loshuGrid,mname,lname,fname}) =>{
	let data;
	if(D !== undefined && C!== undefined && loshuGrid!== undefined)
		data = {loshuGrid,D,C,mname,lname,fname};
	else
		data = {dob,sex,mname,lname,fname};
	let response = await fetch(serverURL+'namecalculator',{
						method:'post',
						headers: {
							'Content-Type': 'application/json',
						},
						body:JSON.stringify(data),
					});
	if (response.status >= 200 && response.status <= 299){
		let returnData = await response.json();
		return returnData;
	}
	else{
		throw response.status;
	}
}

export const fetchTrendBars = async (D) => {
	let data = {D};
	let response = await fetch(serverURL+'trends',{
						method:'post',
						headers: {
							'Content-Type': 'application/json',
						},
						body:JSON.stringify(data),
					});
	if (response.status >= 200 && response.status <= 299){
		let returnData = await response.json();
		return returnData;
	}
	else{
		throw response.status;
	}
}

export const fetchCountryCompatibility = async (D,country) =>{
	let data = {D,country};
	let response = await fetch(serverURL+'country',{
						method:'post',
						headers: {
							'Content-Type': 'application/json',
						},
						body:JSON.stringify(data),
					});
	if (response.status >= 200 && response.status <= 299){
		let returnData = await response.json();
		return returnData.countryCompatibility;
	}
	else{
		throw response.status;
	}
}

export const fetchPartnerCompatibility = async (personData,partnerData) => {
	let data = {personData,partnerData};
	let response = await fetch(serverURL+'partner',{
						method:'post',
						headers: {
							'Content-Type': 'application/json',
						},
						body:JSON.stringify(data),
					});

	if (response.status >= 200 && response.status <= 299){
		let returnData = await response.json();
		return returnData.partnerCompatibility;
	}
	else{
		throw response.status;
	}
}

export const fetchNumerology = async (data) => {
	let response = await fetch(serverURL+'numerology',{
		method:'post',
		headers: {
			'Content-Type': 'application/json',
		},
		body:JSON.stringify(data),
	});

	if (response.status >= 200 && response.status <= 299){
		let returnData = await response.json();
		return returnData.numerology;
	}
	else{
		throw response.status;
	}
}